import {AdvancedMarker, Polyline, useMap} from "@vis.gl/react-google-maps";
import {useEffect} from "react";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import {useSpiderfy} from "../../../../../../hooks/use-spiderfier-adv-marker.js";
import GisUtils from "../../../../gis/utils/gis-utils.jsx";

const iconSize = (zoom) => zoom >= 18 ? "zoom2" : zoom >= 16 ? "zoom1" : "default";

const vmsIcon = (camera, zoom) => {
    const size = iconSize(zoom);
    const suffix = size === "default" ? "" : `-${size}`;
    const color = GisUtils.vmsCameraIcon(camera.iconColor);
    const rotation = Math.round((camera.angle || 0) / 15) * 15 % 360;

    if (color) {
        return getAssetPath(rotation
            ? `img/video-cameras/${color}/rotations${suffix}/${rotation}.png`
            : `img/video-cameras/${color}/${color}${suffix}.png`);
    }

    return getAssetPath(rotation
        ? `img/markers-gis/vms/marker-camera-rotation${suffix}/${rotation}.png`
        : `img/markers-gis/vms/marker-camera${suffix}.png`);
};

const markerKey = (camera) => `${camera.vmsId}-${camera.cameraId ?? camera.id}`;

const CftvMapMarkers = ({center, cameras, integrations, selectedCamera, onSelect, zoom}) => {
    const map = useMap();
    const spiderCameras = cameras.map(camera => ({...camera, id: markerKey(camera), cameraId: camera.id}));
    const {markers, toggleSpiderfy, setSpiderState} = useSpiderfy(spiderCameras, map);
    const isAssociated = (camera) => integrations.some(item =>
        Number(item.id) === Number(camera.cameraId ?? camera.id) && Number(item.vmsId) === Number(camera.vmsId));

    useEffect(() => {
        if (!map) return;

        const listener = map.addListener("click", () => setSpiderState(null));
        return () => listener.remove();
    }, [map, setSpiderState]);

    const handleMarkerClick = (camera) => {
        const result = toggleSpiderfy(camera);
        if (result?.type === "spiderfy") return;

        onSelect({...camera, id: camera.cameraId});
    };

    return (
        <>
            <AdvancedMarker position={center} zIndex={1000} title="Câmera OCR do formulário">
                <div className="relative">
                    <img src={getAssetPath("img/markers-gis/capturePlace/blue.png")} alt="Câmera OCR"/>
                    <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 rounded bg-[#063a6c] px-1.5 py-0.5 text-[10px] font-semibold text-white shadow">
                        OCR
                    </span>
                </div>
            </AdvancedMarker>

            {markers.map(camera => {
                const associated = isAssociated(camera);
                const selected = markerKey(camera) === markerKey(selectedCamera ?? {});

                return (
                    <AdvancedMarker
                        key={markerKey(camera)}
                        position={{lat: camera.lat ?? camera.latitude, lng: camera.lng ?? camera.longitude}}
                        title={`${camera.cameraId} - ${camera.name}`}
                        zIndex={selected ? 900 : associated ? 800 : 500}
                        clickable={true}
                    >
                        <div
                            className={"relative cursor-pointer rounded-full transition-transform " + (selected ? "animate-bounce" : "hover:scale-110")}
                            onClick={() => handleMarkerClick(camera)}
                        >
                            <img src={vmsIcon(camera, zoom)} alt={camera.name}/>
                            {associated && <span className={"absolute -right-1 -top-1 h-3.5 w-3.5 rounded-full border-2 border-white shadow bg-green-500"}/>}
                        </div>
                    </AdvancedMarker>
                );
            })}

            {markers.map(camera => {
                if (!camera.original) return null;

                return (
                    <Polyline
                        key={`line-${markerKey(camera)}`}
                        path={[camera.original, {lat: camera.lat, lng: camera.lng}]}
                        strokeColor="#000"
                        strokeOpacity={0.7}
                        strokeWeight={2}
                    />
                );
            })}
        </>
    );
};

export default CftvMapMarkers;
